<template>
    <v-menu>
        <template v-slot:activator="{ props }">
            <v-btn style="width: 2rem; height: 2rem; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                icon="mdi-dots-horizontal" class="acao-secundaria" v-bind="props"></v-btn>
        </template>

        <v-list>
            <v-list-item @click="$emit('iniciarSprint', item, item.dtTermino == null ? '' : 'finalizar')"
                :disabled="item.dtInicio == null && item.dtTermino !== null" :style="{
                    cursor: (item.dtInicio == null && item.dtTermino !== null) ? 'not-allowed' : 'pointer',
                    color: (item.dtInicio == null && item.dtTermino !== null) ? 'grey' : 'var(--cor-fonte)'
                }">
                {{ item.dtTermino == null ? 'Iniciar Sprint' : 'Finalizar Sprint' }}
            </v-list-item>
            <v-list-item v-if="item.dtInicio !== null" @click="$emit('editarDatas', item, '')">
                Alterar Datas
            </v-list-item>
            <v-list-item @click="confirmarExclusão" class="txt-erro">
                Excluir Sprint
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'OptionsSprint',
    props: {
        item: {
            required: true,
        },
    },
    methods: {
        confirmarExclusão() {
            if (this.item.backlogs.length > 0 ? confirm('Tem certeza? Todas as tarefas desta sprint serão excluídas.') : true) {
                this.$emit('apagarSprint', this.item.id);
            }
        },
    },
}
</script>

<style scoped></style>